var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPlusPreimagine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector Path",
    d: "M18.6 11.4H12.6V5.40002H11.4V11.4H5.40002V12.6H11.4V18.6H12.6V12.6H18.6V11.4Z",
    fill: "#0562D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlusPreimagine);
export default __webpack_public_path__ + "static/media/search-plus-preimagine.00379b5d001483b009ee38c168f5b998.svg";
export { ForwardRef as ReactComponent };